// site logo
import { Spin } from 'antd';

export default function WebbSpinner() {

  return (
    <>
      <div className="" >
        <Spin />
      </div>
  
    </>
    )
  }